import { usePropertyUrl } from '~/utilities/usePropertyUrl';

export function useSportradarVerticalTopic(): {
  vertical: string;
  topic: string;
} {
  const propertyUrl = usePropertyUrl();

  // Get the last 2 parts of the propertyUrl slug
  const [vertical, topic] = propertyUrl.split('/').slice(-2);

  return { vertical: vertical, topic: topic };
}
